import React from 'react';
import { bonuses } from '../data/bonuses';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-forest py-16 sm:py-24" data-id="element-15" data-mp="pjg5q15wl80x">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-16" data-mp="au1rofrdu2f7">
        <SectionHeading id="bonuses-heading" intro={<>
              Realna wartość <span className="line-through" data-id="element-18" data-mp="1un3xo2lo5ye">$250</span> —{' '}
              <span className="font-semibold text-gold" data-id="element-19" data-mp="1whrzb964e6p">dziś w zestawie za darmo.</span>
            </>} data-id="element-17" data-mp="fu69qa7xv57j">
          Pięć <span className="text-gold" data-id="element-20" data-mp="3o1lhcx8wzvm3">bonusów</span>
        </SectionHeading>
        <ul className="mt-10 grid gap-5 sm:mt-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="3o3pu84osk4yi">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-forest-soft bg-card shadow-card-dark" data-id="element-22" data-mp="1ma8l0wl0iw1n">
              <img src={bonus.image} alt={`Okładka: ${bonus.title}`} className="aspect-square w-full object-cover" data-id="element-23" data-mp="1r80dpsthem6w" />
              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-24" data-mp="3icvan7ku2bzt">
                <span className="w-fit rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-ink" data-id="element-25" data-mp="3dg4xas0exui3">
                  Bonus {bonus.number} · {bonus.value} · Gratis
                </span>
                <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-white" data-id="element-26" data-mp="3n6g36k3nqdrm">{bonus.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-copy-light" data-id="element-27" data-mp="2zfu77r6xgjxz">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}